"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
interface TourCatalogPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}
export function TourCatalogPagination(t0) {
  const $ = _c(23);
  const {
    page,
    totalPages,
    onPageChange
  } = t0;
  if (totalPages <= 1) {
    return null;
  }
  const isFirstPage = page <= 0;
  const isLastPage = page >= totalPages - 1;
  let t1;
  if ($[0] !== onPageChange || $[1] !== page) {
    t1 = () => {
      onPageChange(page - 1);
    };
    $[0] = onPageChange;
    $[1] = page;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronLeft className="size-4" />;
    t3 = <span className="hidden sm:inline">Previous</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isFirstPage || $[6] !== t1) {
    t4 = <Button aria-label="Previous page" disabled={isFirstPage} onClick={t1} size="sm" type="button" variant="outline">{t2}{t3}</Button>;
    $[5] = isFirstPage;
    $[6] = t1;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = page + 1;
  let t6;
  if ($[8] !== t5 || $[9] !== totalPages) {
    t6 = <span className="min-w-20 text-center text-xs text-muted-foreground tabular-nums">Page {t5} of {totalPages}</span>;
    $[8] = t5;
    $[9] = totalPages;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onPageChange || $[12] !== page) {
    t7 = () => {
      onPageChange(page + 1);
    };
    $[11] = onPageChange;
    $[12] = page;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="hidden sm:inline">Next</span>;
    t9 = <ChevronRight className="size-4" />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isLastPage || $[17] !== t7) {
    t10 = <Button aria-label="Next page" disabled={isLastPage} onClick={t7} size="sm" type="button" variant="outline">{t8}{t9}</Button>;
    $[16] = isLastPage;
    $[17] = t7;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t4 || $[21] !== t6) {
    t11 = <nav aria-label="Tour catalog pagination" className="flex items-center justify-center gap-2">{t4}{t6}{t10}</nav>;
    $[19] = t10;
    $[20] = t4;
    $[21] = t6;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}